var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:['status', _vm.overpackStatus.status]},[_vm._v(_vm._s(_vm.overpackStatus.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }